import { Text } from '@/components/shared/components/Text';

export const contactPersonFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.5,
    field: 'contactPerson',
    sortable: false,
    align: 'left',
    headerName: <Text tId={'CONTACT_PERSON'} />,
    renderCell: (rowData) => (
      <>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'break-spaces',
            lineHeight: '1.43',
          }}
        >
          <div className={'line-clamp-3'}>
            {`${rowData.row.registrationFields.fullName.firstName} ${rowData.row.registrationFields.fullName.lastName}`}
          </div>
        </div>
      </>
    ),
  };
};
